import { useEffect, useState } from 'react'

// A ring around the current target with the rest of the page dimmed. pointer-events: none, so the
// page underneath stays fully usable — the guide never blocks a click.
export function findAnchor(anchor: string): HTMLElement | null {
  for (const el of document.querySelectorAll<HTMLElement>(`[data-tutorial-anchor="${anchor}"]`)) {
    if (el.getClientRects().length > 0) return el
  }
  return null
}

export function useAnchorRect(anchor: string | null): DOMRect | null {
  const [rect, setRect] = useState<DOMRect | null>(null)

  useEffect(() => {
    if (!anchor) {
      setRect(null)
      return
    }
    let frame = 0
    const measure = () => {
      cancelAnimationFrame(frame)
      frame = requestAnimationFrame(() => setRect(findAnchor(anchor)?.getBoundingClientRect() ?? null))
    }
    measure()
    const timer = window.setInterval(measure, 500)
    window.addEventListener('scroll', measure, true)
    window.addEventListener('resize', measure)
    return () => {
      cancelAnimationFrame(frame)
      window.clearInterval(timer)
      window.removeEventListener('scroll', measure, true)
      window.removeEventListener('resize', measure)
    }
  }, [anchor])

  return rect
}

export default function Spotlight({ rect }: { rect: DOMRect }) {
  const pad = 6
  return (
    <div
      className="t0-spotlight"
      aria-hidden="true"
      style={{ top: rect.top - pad, left: rect.left - pad, width: rect.width + pad * 2, height: rect.height + pad * 2 }}
    />
  )
}
